import type { OrganizationMembership } from '@/types';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * useOrgRegisterGate
 *
 * This hook is used to redirect users to the organization registration
 * page if they do not have any organizations.
 *
 * @param {boolean} isLoadingOrganizations - Whether the
 *   organizations are currently being loaded.
 * @param {OrganizationMembership[] | null} organizations - The
 *   user's current organizations.
 */

export function useOrgRegisterGate(
  isLoadingOrganizations: boolean,
  organizations?: OrganizationMembership[] | null
) {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (
      !isLoadingOrganizations &&
      !organizations &&
      location.pathname !== '/organization/register'
    ) {
      navigate('/organization/register', { replace: true });
    } else if (
      !isLoadingOrganizations &&
      organizations &&
      location.pathname !== '/organization/register'
    ) {
      if (organizations.length === 0) {
        navigate('/organization/register', { replace: true });
      }
    }
  }, [isLoadingOrganizations, organizations, navigate, location.pathname]);
}
